import { useTranslation } from 'react-i18next';
import HeadingIcon from '@assets/icons/users.svg?react';
import photoJA from '@assets/photos/photo_ja_square.png';
import photoAE from '@assets/photos/photo_ae_square.png';

export const About = () => {
    const { t } = useTranslation();

    const teamMembers = [
        {
            name: t('about.JA_name'),
            title: t('about.JA_title'),
            description: t('about.JA_description'),
            imageUrl: photoJA
        },
        {
            name: t('about.AE_name'),
            title: t('about.AE_title'),
            description: t('about.AE_description'),
            imageUrl: photoAE
        }
    ];

    return (
        <section
            id="about"
            className="w-full py-8 md:py-12 bg-sectbg1"
        >
            <div className="max-w-[1280px] mx-auto px-8">
                {/* Grid: 1 column on mobile/tablet, 3 columns on desktop */}
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
                    {/* Column 1: Heading */}
                    <div className="lg:col-span-1">
                        <h2 className="text-4xl font-bold text-secttxthead tracking-tight flex items-center gap-x-4">
                            <HeadingIcon className="h-9 w-auto" />
                            <span>{t('nav.about')}</span>
                        </h2>
                    </div>

                    {/* Column 2: Content (spans 2 of 3 columns on desktop) */}
                    <div className="lg:col-span-2">
                        <div className="space-y-12">
                            {teamMembers.map((member) => (
                                // Person item layout
                                <div key={member.name} className="grid grid-cols-1 gap-y-4">
                                    <img
                                        className="h-36 w-36 rounded-full object-cover"
                                        src={member.imageUrl}
                                        alt={`Photo of ${member.name}`}
                                    />
                                    <div>
                                        <p className="text-xl font-medium text-secttxtprim">{member.name}</p>
                                        <p className="text-base font-normal text-secttxtsec">{member.title}</p>
                                        <p className="text-lg font-normal text-secttxtprim mt-4">{member.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};